class HubspotForm extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector('form');
        this.submit = this.querySelector('button');
        this.url = this.dataset.url;
        this.submit.addEventListener('click', this.handleForm.bind(this))
    }
    
    async handleForm(e) {
        e.preventDefault();
        if(!this.url) return 

        if(!this.form.checkValidity()) {
            this.form.reportValidity();
            return;
        }
        const fields = this.getFields();
    
        if(!fields) return
        const config = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        }
        config.body = JSON.stringify({fields});
        
        this.submit.setAttribute('disabled', 'disabled');
        this.submit.textContent = 'SENDING...';

        try{
            const response = await fetch(this.url, config);
            if (response.ok) {
                this.showSuccess();
            } else {
                alert('Submission failed. Please try again.');
                this.submit.removeAttribute('disabled');
                this.submit.textContent = 'SUBMIT';
            }
        } catch(e) {
            this.submit.removeAttribute('disabled');
            this.submit.textContent = 'SUBMIT';
            throw e;
        }
            
    }

    showSuccess() {
        this.form.reset();
        const successMessage = this.querySelector('.ajax-success-message');
        if (successMessage) {
            successMessage.style.display = 'block';
            this.form.style.display = 'none';
        } else {
            alert('Thank you! Your message has been sent.');
        }
    }

    getFields() {
        const formData = new FormData(this.form);
        const arr = [];
        for (const [key, value] of formData.entries()) {
            if (key === 'privacy-police') continue;
            if(key == 'fullname' ) {
                const [firstName, lastName] = value.split(' ');
                lastName ? arr.push({ name:"firstname", value: firstName}, { name:"lastname", value: lastName}) : arr.push({ name:"firstname", value: firstName})
            } else {
                arr.push({ name:key, value: value})
            }
        }
        return arr;
    }
}
customElements.define('hubspot-form', HubspotForm);